import { render, staticRenderFns } from "./ConfigurationsExternalDriverFees.vue?vue&type=template&id=cd95fa92&scoped=true"
import script from "./ConfigurationsExternalDriverFees.vue?vue&type=script&lang=js"
export * from "./ConfigurationsExternalDriverFees.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationsExternalDriverFees.vue?vue&type=style&index=0&id=cd95fa92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd95fa92",
  null
  
)

export default component.exports